import React from 'react';

type MainLayoutProps = {
  header: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
};

export default function MainLayout({ header, children, footer, className = 'app-shell' }: MainLayoutProps) {
  return (
    <div className={className}>
      {header}
      {children}
      {footer}
    </div>
  );
}
